
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"112","height":"112","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M84.438 50.313a4.375 4.375 0 100-8.75 4.375 4.375 0 000 8.75z","fill":"#52B788"}}),_c('path',{attrs:{"d":"M94.5 8.75h-5.688V4.375a4.375 4.375 0 10-8.75 0V8.75H60.157V4.375a4.375 4.375 0 10-8.75 0V8.75H31.72V4.375a4.375 4.375 0 10-8.75 0V8.75H17.5C7.85 8.75 0 16.6 0 26.25V94.5c0 9.649 7.85 17.5 17.5 17.5h33.469a4.375 4.375 0 000-8.75H17.5c-4.825 0-8.75-3.925-8.75-8.75V26.25c0-4.825 3.925-8.75 8.75-8.75h5.469v4.375a4.375 4.375 0 108.75 0V17.5h19.687v4.375a4.375 4.375 0 108.75 0V17.5h19.907v4.375a4.375 4.375 0 108.75 0V17.5H94.5c4.825 0 8.75 3.925 8.75 8.75v24.938a4.375 4.375 0 008.75 0V26.25c0-9.65-7.851-17.5-17.5-17.5z","fill":"#52B788"}}),_c('path',{attrs:{"d":"M85.531 59.063c-14.595 0-26.469 11.873-26.469 26.468S70.936 112 85.532 112C100.125 112 112 100.126 112 85.531s-11.874-26.469-26.469-26.469zm0 44.187c-9.77 0-17.719-7.948-17.719-17.719 0-9.77 7.95-17.719 17.72-17.719s17.718 7.949 17.718 17.72c0 9.77-7.949 17.718-17.719 17.718z","fill":"#52B788"}}),_c('path',{attrs:{"d":"M91.875 81.156h-1.969v-4.594a4.375 4.375 0 10-8.75 0v8.97a4.375 4.375 0 004.375 4.374h6.344a4.375 4.375 0 100-8.75zM65.406 50.313a4.375 4.375 0 100-8.75 4.375 4.375 0 000 8.75zM46.375 69.344a4.375 4.375 0 100-8.75 4.375 4.375 0 000 8.75zM27.344 50.313a4.375 4.375 0 100-8.75 4.375 4.375 0 000 8.75zM27.344 69.344a4.375 4.375 0 100-8.75 4.375 4.375 0 000 8.75zM27.344 88.375a4.375 4.375 0 100-8.75 4.375 4.375 0 000 8.75zM46.375 88.375a4.375 4.375 0 100-8.75 4.375 4.375 0 000 8.75zM46.375 50.313a4.375 4.375 0 100-8.75 4.375 4.375 0 000 8.75z","fill":"#52B788"}})])
          )
        }
      }
    